const React = require('react')
const { useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { TableHeader } = require('../table')

require('@styles/pages/address/contract.address.css')

const UnverifiedContract = props => {
    const { data } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()

    const [viewType, setViewType] = useState('bytecodes')

    return (
        <>
            <TableHeader
                title={
                    <>
                        Are you the contract creator?&nbsp;
                        <span
                            className={`${network.name}-text-color cursor-pointer`}
                            onClick={() => history.push(`/${network.name}/verifyContract?a=${address}`)}
                        >
                            Verify and Publish
                        </span>
                        &nbsp;your contract source code today!
                    </>
                }
                usePagination={false}
            />
            <div style={{ padding: '16px 0', display: 'flex', gap: '12px' }}>
                <Button
                    className={`small-button ${network.name}-tab-button active`}
                    onClick={() => history.push(`/${network.name}/bytecode-decompiler?a=${address}`)}
                >
                    Decompile Bytecode
                    <i className='fas fa-up-right-from-square' style={{ marginLeft: '8px' }} />
                </Button>
                <Button
                    className={`small-button ${network.name}-tab-button active`}
                    onClick={() => setViewType(viewType === 'opcodes' ? 'bytecodes' : 'opcodes')}
                >
                    {viewType === 'opcodes' ? 'Switch Back To Bytecodes View' : 'Switch To Opcodes View'}
                </Button>
            </div>
            <div style={{ paddingBottom: '24px' }}>
                <div
                    style={{
                        width: '100%',
                        height: '200px',
                        backgroundColor: 'var(--pending-background-color)',
                        color: 'var(--grey-color)',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        wordBreak: 'break-all',
                        overflowY: 'auto'
                    }}
                >
                    {viewType === 'bytecodes' ? <>{data?.information.bytecode}</> : <>{network.name}</>}
                </div>
            </div>
        </>
    )
}

module.exports = { UnverifiedContract }
